import { FwSupportedCurrenciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useSupportedCurrencies = () => {
  const { data, loading } = useQuery(FwSupportedCurrenciesDocument, {
    fetchPolicy: 'network-only',
  })

  const supportedCurrencies =
    data?.finance.exchangeCurrenciesConnection.nodes.map((i) => i.id) ?? []

  return { supportedCurrencies, loading }
}
